// extracted by mini-css-extract-plugin
module.exports = {"button":"styles__button___Kwv8a","cancel":"styles__cancel___1lwX2"};